module.exports = __webpack_public_path__ + "static/sport/bg.fbaa60c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/bg.jpg
// module id = t27e
// module chunks = 0